import $ from 'jquery';
import _ from 'lodash';
import ComponentBasePrototype from 'ComponentBasePrototype';
import Config from '../../../base/pride.config';
import RequestUtils from '../../../base/request/request';
import FormBase from './form-base';
import Form from '../../../base/ui/form/form';

export default class FormLoader extends ComponentBasePrototype {

  build() {
    this.contentNode = this.node.find('.form-loader__content');
    this.loaderNode = this.node.find('.form-loader__loader');
    this.loadForm();
  }

  loadForm() {
    const apiUrl = Config.form.api_url;
    // No api url present
    if (!apiUrl) {
      return;
    }

    let queryParams = {
      form: this.data.form,
      id: RequestUtils.getQueryParam('id'),
      error: RequestUtils.getQueryParam('error'),
      path: RequestUtils.getQueryParam('path'),
      lang: RequestUtils.getQueryParam('lang'),
      valitse: RequestUtils.getQueryParam('valitse'),
      status: RequestUtils.getQueryParam('status'),
    };

    queryParams = _.pickBy(queryParams, _.identity);

    $.get(`${apiUrl}&${$.param(queryParams)}`)
      .then(
        response => this.onSuccess($(response)),
        response => this.onFail(response),
      );
  }

  onFail() {

  }

  onSuccess(node) {
    const formComponent = node.filter('[data-component=form]:first');

    this.contentNode.append(node).removeClass('hidden');
    this.loaderNode.addClass('hidden');

    if (formComponent.length > 0) {
      new FormBase(node, {}).build();
      Form.build($('body'));
      this.eventBus.publish('build_component', node);
    }
  }
}
